var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "备注",
        visible: _vm.visible,
        width: "552px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "small",
            "label-width": "96px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "手机号备注", prop: "remarks" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入",
                  clearable: "",
                  maxlength: "64",
                  type: "textarea",
                  rows: "3",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remarks", $$v)
                  },
                  expression: "form.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.ok } },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }